<template>
    <div class="dayListFirst">
        <van-row :class="['cardContainer', isShowHistory ? 'historyMode' : '']">
            <van-col span="5" class="dayColumn">
                <div class="dayImage">
                    <img class="calendarImage" src="@/assets/firstRecharge/calendarFR3.png" alt="">
                    <!-- <div class="dateText" v-if="props.time">{{ formatUnixTimestamp(props.time)?.split(' ')[0] }}</div> -->
                    <div class="dateText" v-if="props.time">
                        <span class="date-year">{{ formatUnixTimestamp(props.time)?.split(' ')[0]?.split('-')[0]
                            }}</span>
                        <span class="date-month">{{ getMonthName(props.time) }}</span>
                        <span class="date-day">{{ formatUnixTimestamp(props.time)?.split(' ')[0]?.split('-')[2]
                            }}</span>
                    </div>

                    <div class="dayText" v-else>{{ props.day }}</div>
                </div>
            </van-col>
            <van-col span="14" style="padding:0 10px; display: flex; align-items: center;">
                <van-col span="24">
                    <van-row>
                        <van-col span="24"
                            v-if="isShowHistory ? true : checkDate(formatUnixTimestamp(props.time)) == 0">
                            <van-row class="topData">
                                <van-col span="12" class="topCol">
                                    <div class="toptext">{{ $t('activity.available') }}</div>
                                    <div class="toptext-amount">{{ formatCurrency(availableAmount) }}</div>
                                </van-col>
                                <van-col span="12" class="topCol">
                                    <div class="toptext">{{ $t('activity.givenAmount') }}</div>
                                    <div class="toptext-amount">{{ formatCurrency(givenAmount) }}</div>
                                </van-col>
                            </van-row>
                        </van-col>

                        <van-col span="24" style="padding-left: 5px;">
                            <span
                                v-bind:class="['middle-texts', props.activityStatus == 0 || props.activityStatus == 11 || props.activityStatus == 2 ? 'middle-pending' : '']">
                                <p style="color: rgb(190 220 255); font-weight: 600;">
                                    {{ $t(props.labelOne || '') }}:{{ props.currenyLable ? 'R$' : '' }}
                                    {{ props.valueOne }}{{ props.currenyLable ? '' : '%' }}
                                </p>
                                <p>{{ $t(props.labelTwo || '') }}: <span style="color: #ffe0a1 ; font-weight: 600;">{{
                                    props.valueTwo }}X</span></p>
                            </span>
                        </van-col>
                    </van-row>
                </van-col>
            </van-col>
            <van-col span="5" style="padding-left: 10px; display: flex; align-items: center; justify-content: center; ">
                <div class="claimBtn"
                    v-if="isShowHistory ? false : activityStatus == 0 && checkDate(formatUnixTimestamp(props.time)) == 0">
                    <div class="click_btn" @click="clickOnButton">
                        {{ $t('activity.click') }}
                    </div>
                </div>
                <span class="right-texts" v-else>
                    <img src="@/assets/firstRecharge/gitfBoxFR3.png" class="status-gift-icon" alt="" />
                    <div v-if="props.activityStatus == 0 && returnTurnover" class="status-badge status-norewards">
                        {{ $t('activityStatus.noRewards') }}
                    </div>
                    <div v-else-if="props.activityStatus == 0 || props.activityStatus == 11"
                        class="status-badge status-pending">
                        {{ $t('activityStatus.pending') }}
                    </div>
                    <div v-else-if="props.activityStatus == 1" class="status-badge status-completed">
                        {{ $t('activityStatus.completed') }}
                    </div>
                    <div v-else-if="props.activityStatus == 2" class="status-badge status-norewards">
                        {{ $t('activityStatus.noRewards') }}
                    </div>
                    <div v-else-if="props.activityStatus == 3" class="status-badge status-norewards">
                        {{ $t('activity.overdue') }}
                    </div>
                </span>
            </van-col>

        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { } from 'vue';
import { checkDate, formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';

const props = defineProps({
    day: {
        type: Number
    },
    valueOne: {
        type: Number
    },
    valueTwo: {
        type: Number
    },
    currenyLable: {
        type: Boolean
    },
    labelOne: {
        type: String
    },
    labelTwo: {
        type: String
    },
    time: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
    isShowHistory: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['getClaim'])

const getMonthName = (timestamp: number) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const lang = localStorage.getItem('lang') === 'pt' ? 'pt-BR' : 'en-US';
    let monthStr = date.toLocaleString(lang, { month: 'short' }).replace('.', '');
    return monthStr.charAt(0).toUpperCase() + monthStr.slice(1);
}

const clickOnButton = () => {
    emits('getClaim')
}
</script>
<style scoped>
.cardContainer {
    background-image: linear-gradient(rgb(0 28 46 / 60%), rgb(14 42 93 / 60%)), url(http://localhost:8080/img/cardBackground3.b1f652af.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 2px solid rgb(0 67 171 / 50%);
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 10px rgb(166 185 255 / 20%), inset 0 0 15px rgb(166 216 255 / 5%);
    padding: 10px;
    color: #fff;
    font-size: 12px;
    margin: 10px 15px 0;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayImage .calendarImage {
    width: 100%;
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 0 8px rgba(148, 211, 242, 0.8));
}

.dayImage .bgImage {
    position: absolute;
    width: 100%;
    z-index: 0;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.day-num {
    position: absolute;
    font-size: 25px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 30%;
}

.dateText {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    line-height: 1.3;
    text-align: center;
}

.dateText .date-year {
    font-size: 8px;
    color: #dbebff;
    font-weight: 700;
    letter-spacing: 0.5px;
}

.dateText .date-month {
    font-size: 9px;
    color: #dbebff;
    font-weight: 700;
    letter-spacing: 0.5px;

}

.dateText .date-day {
    font-size: 10px;
    color: #dbebff;
    font-weight: 800;
    letter-spacing: 1px;
}

.dayText {
    position: absolute;
    top: 25%;
    font-size: 200%;
    color: #a2d8e9;
    font-weight: 600;
    z-index: 2;
}

.topData {
    margin-bottom: 5px;
    padding: 10px 0;
}

.topCol {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.toptext {
    padding: 5px 0 0;
    font-size: 12px;
    color: #b1b9ff;
}

.toptext-amount {
    font-size: 12px;
    padding: 5px;
    color: #ffcd4b;
}

.coins-img {
    position: absolute;
    right: 0rem;
    top: 35%;
    z-index: 800;
    width: 18%;
}

.div-card {
    width: 100%;
    padding: 0.5rem;
    padding-left: 0rem;
    /* height: 70px; */
}

.middle-pending {
    top: 2vh;
}

.middle-texts p {
    margin: 5px 0px !important;
    font-size: 78%;
}

.right-texts {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.status-gift-icon {
    width: 70%;
    margin-bottom: 5px;
    background-image: url('@/assets/firstRecharge/gitfBoxBackgroundFR.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.right-texts p {
    margin: 0px !important;
    font-size: 78%;
    top: 2.5vh;
}

.click_btn {
    color: #4d90f5;
    font-size: 12px;
    font-weight: 600;
    background-color: #1a000054;
    border: 1.5px solid #1b339a;
    border-radius: 30px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-top: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgb(148 188 242 / 20%);

}

.click_btn:hover {
    background-color: #4186e7;
    color: #041736;
    box-shadow: 0 4px 12px rgba(0, 38, 91, 0.4);
}

@media (min-width:450px) {
    .day-num {
        font-size: 200%;
        top: 31%;
    }

    .middle-texts {
        left: 22%;
    }

    .right-texts {
        left: 62%;
    }

    .coins-img {
        width: 25%;
        top: 1rem;
    }

    .div-card {
        height: none;
    }

    .middle-texts p {
        font-size: 100%;
    }

    .right-texts p {
        font-size: 100%;
    }

    .dateText {
        font-size: 11px;
    }
}


@media (max-width:380px) {
    .dateText {
        font-size: 8px;
    }

    .dayText {
        display: flex;
        align-items: center;
    }

    .status-gift-icon {
        width: 65%;
        margin-bottom: 1px;
    }

    .status-badge {
        font-size: 7px;
        padding: 1px 2px;
        min-width: unset;
        white-space: nowrap;
        transform: scale(0.85);
    }

    .middle-texts p {
        font-size: 80%;
    }

    .right-texts p {
        font-size: 65%;
    }
}

@media (max-width: 360px) {
    .dateText .date-year {
        font-size: 7px;
    }

    .dateText .date-month {
        font-size: 8px;
    }

    .dateText .date-day {
        font-size: 9px;
    }

    .toptext {
        font-size: 10px;
    }

    .click_btn {
        font-size: 10px;
        padding: 6px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}

.status-badge {
    padding: 3px 10px;
    border-radius: 15px;
    color: #fff;
    font-weight: 600;
    font-size: 11px;
    text-align: center;
    white-space: nowrap;
    margin-top: 0px;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
    min-width: 65%;
    box-sizing: border-box;
}

.status-pending {
    background-color: #3264c8;
    border: 1.5px solid #6b9cf6;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4), inset 0 0 5px rgba(107, 156, 246, 0.5);
}

.status-completed {
    background-color: #2e8233;
    border: 1.5px solid #6ed174;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4), inset 0 0 5px rgba(110, 209, 116, 0.5);
}

.status-norewards {
    background-color: #c42d2d;
    border: 1.5px solid #ff6b6b;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4), inset 0 0 5px rgba(255, 107, 107, 0.5);
}
</style>
